// Whether our success fee on a dispute has been settled. Only a win incurs a fee, so
// everything else has nothing to pay and reads as a dash rather than a misleading "Unpaid".
// `not_billable` exists only as a filter value — a row carries `null` for it.
export const PAID_STATUS_LABELS = {
  paid: "Paid",
  unpaid: "Unpaid",
  not_billable: "No fee due"
}

export const PAID_STATUS_COLORS = { paid: "success", unpaid: "error" }

export const PAID_STATUS_DATA = Object.entries(PAID_STATUS_LABELS).map(([id, name]) => ({
  id,
  name
}))
